import { FamilyApplicationQueries } from '@/queries/family_applications/queries'
import { RefreshFamilyApplication } from '@/app-storage/applications/familyApplicationSlice'
import { AppDispatch, RootState } from '@/app-storage/store'
import { usePrefetchQuery } from '@tanstack/react-query'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectProgramID } from '@/app-storage/program_settings/programSettingsSlice.ts'
import LoadingCard from './common/components/LoadingCard'
import { FullCenteredMain } from '@/layouts/FullCenteredLayout'
import { useTranslation } from 'react-i18next'
import { useApplicantProgramYears } from '@/app/SchoolYearProvider.tsx'
import { useSyncTransferStudents } from '@/app/services/useSyncTransferStudents.ts'

function RefreshApplication({ children }: { children: React.ReactNode }) {
  const { t: translate } = useTranslation()
  const { selectedProgramId } = useApplicantProgramYears()
  const ProgramId = useSelector(selectProgramID)
  const dispatch = useDispatch<AppDispatch>()
  const familyApplication = useSelector(
    (state: RootState) => state.FamilyApplication
  )

  usePrefetchQuery(FamilyApplicationQueries.getCompetingPrograms(ProgramId))

  useEffect(() => {
    dispatch(RefreshFamilyApplication(selectedProgramId)) // If we use ProgramId here, it will cause a waterfall effect with the API calls
  }, [selectedProgramId])

  useSyncTransferStudents()

  if (!familyApplication.data) {
    return (
      <FullCenteredMain>
        <LoadingCard isLoading={true}>
          <span>{translate('authorizing')}</span>
        </LoadingCard>
      </FullCenteredMain>
    )
  }

  return children
}

export default RefreshApplication
